import { render, staticRenderFns } from "./editLabel.vue?vue&type=template&id=5de4e9a6"
import script from "./editLabel.vue?vue&type=script&lang=js"
export * from "./editLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports